"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("../lib");
const parseQuery_1 = __importDefault(require("./parseQuery"));
const deleteModel = async (Model, payload, options) => {
    await Model._init();
    options = Object.assign({}, {
        hooks: true,
        clearCache: true,
        updateStore: true,
    }, options);
    const args = { payload };
    if (options.hooks) {
        const responses = await Model.execHook("preDelete", [args]);
        if (responses === null || responses === void 0 ? void 0 : responses.includes(false)) {
            return;
        }
    }
    if (payload instanceof lib_1.GraphandModel) {
        try {
            const { _id } = payload;
            await Model._client._axios.delete(`${Model.baseUrl}/${_id}`, { global: Model.isGlobal });
            if (options.updateStore) {
                const updated = Model.deleteFromStore([payload]);
                if (updated) {
                    Model.clearCache();
                }
            }
            if (options.hooks) {
                await Model.execHook("postDelete", [null, args]);
            }
        }
        catch (e) {
            Model.upsertStore([payload]);
            if (options.hooks) {
                await Model.execHook("postDelete", [e, args]);
            }
            throw e;
        }
    }
    else {
        try {
            if (payload.query) {
                payload.query = (0, parseQuery_1.default)(payload.query);
            }
            // @ts-ignore
            const { data } = await Model._client._axios.delete(Model.baseUrl, { _data: payload });
            if (!data) {
                return;
            }
            const ids = data.data.ids;
            if (options.updateStore) {
                const updated = Model.deleteFromStore(ids);
                if (updated) {
                    Model.clearCache();
                }
            }
            if (options.hooks) {
                await Model.execHook("postDelete", [null, args]);
            }
        }
        catch (e) {
            if (options.hooks) {
                await Model.execHook("postDelete", [e, args]);
            }
            throw e;
        }
    }
    return true;
};
exports.default = deleteModel;
